import React, { useState } from "react";
import { Download, ExternalLink, FileText, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { PdfViewer } from "@/components/PdfViewer";
import { previewPdf } from "@/lib/pdfPreview";

export const InvoicePdfButton = ({ inv, prefix }) => {
  const [busy, setBusy] = useState(false);
  const [url, setUrl] = useState(""), [blob, setBlob] = useState(null);
  const name = `riepilogo-${inv.month}.pdf`;
  const open = async () => {
    setBusy(true);
    try {
      const { data } = await api.get(`/invoices/${inv.id}/pdf`, { responseType: "blob" });
      const b = new Blob([data], { type: "application/pdf" });
      previewPdf(b, name);
    } catch { toast.error("PDF non disponibile"); }
    finally { setBusy(false); }
  };
  const close = () => { URL.revokeObjectURL(url); setUrl(""); setBlob(null); };
  const save = () => { const a = document.createElement("a"); a.href = url; a.download = name; a.click(); };
  return <>
    <Button size="sm" variant="outline" onClick={open} disabled={busy} data-testid={`${prefix}-pdf-${inv.id}`}>
      {busy ? <Loader2 className="w-3.5 h-3.5 mr-1 animate-spin" /> : <FileText className="w-3.5 h-3.5 mr-1" />}PDF
    </Button>
    <Dialog open={!!url} onOpenChange={(v) => { if (!v) { close(); } }}>
      <DialogContent className="max-w-4xl w-[95vw]" data-testid={`${prefix}-pdf-dialog-${inv.id}`}>
        <DialogHeader><DialogTitle>Utilizzo servizi MarkooPlace · {inv.label || inv.month}</DialogTitle></DialogHeader>
        {blob && <PdfViewer blob={blob} className="h-[70vh]" testid={`${prefix}-pdf-frame-${inv.id}`} />}
        <div className="flex flex-wrap justify-end gap-2">
          <Button variant="outline" onClick={() => window.open(url, "_blank", "noopener")} data-testid={`${prefix}-pdf-newtab-${inv.id}`}><ExternalLink className="w-4 h-4 mr-1" />Apri in nuova scheda</Button>
          <Button onClick={save} data-testid={`${prefix}-pdf-download-${inv.id}`}><Download className="w-4 h-4 mr-1" />Scarica PDF</Button>
        </div>
      </DialogContent>
    </Dialog>
  </>;
};
